type Section5ExitProps = {
  onIntakeContact: () => void;
};

export function Section5Exit({ onIntakeContact }: Section5ExitProps) {
  return (
    <section className="mt-2 bg-gradient-to-br from-coral-50 to-surface-50 px-5 pb-8 pt-10">
      <p className="kicker mb-3.5">第五段 · 想清楚了</p>
      <h2 className="mb-3.5 text-[26px] font-bold leading-tight tracking-tight text-ink-900">
        看到这里,
        <br />
        <span className="text-coral-700">你心里多半已经有了倾向。</span>
      </h2>
      <p className="mb-7 text-sm leading-[1.75] text-ink-600">
        但攻略写的是常识,你的情况是具体的——预算、入住时间、室友、宠物、过敏……都该有人陪你拆。
      </p>

      <button type="button" onClick={onIntakeContact} className="btn-primary">
        <span className="flex items-center gap-2">
          先说说你的情况
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
            <path
              d="M2.5 7h9M8 3.5L11.5 7 8 10.5"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      <div className="mt-6 flex items-center gap-3.5 rounded-[18px] border border-[var(--line-soft)] bg-paper px-[18px] py-4">
        <div className="flex shrink-0">
          {["L", "Z", "W"].map((initial, i) => (
            <div
              key={initial}
              className={`flex h-8 w-8 items-center justify-center rounded-full border-2 border-paper text-xs font-extrabold text-white ${
                i > 0 ? "-ml-2.5" : ""
              }`}
              style={{
                background: ["#FF6B5A", "#4DB394", "#FFB54A"][i],
                zIndex: 3 - i,
              }}
            >
              {initial}
            </div>
          ))}
        </div>
        <p className="text-[12.5px] leading-snug text-ink-700">
          回复速度通常{" "}
          <strong className="font-bold text-coral-700">≤ 30分钟</strong>
          <br />
          <span className="text-[11.5px] text-ink-400">周末与新加坡公共假期相同</span>
        </p>
      </div>
    </section>
  );
}
